import { createSlice } from '@reduxjs/toolkit'

type ProcessedRecords = {
  records: {
    amount: number,
    id: string,
    bulkId: string,
    tag: string,
    beneficiary: {
      account: string,
      accountOwnerNames: string,
      bank: string,
      bankCode: string,
      currency: string,
    },
    narration: string,
    customerReference: string,
    validationResponse: {
      category: string,
      displayName: string,
      status: string,
      validationResults: {
        displayName: string,
        status: string,
      },
    },
  }[],
  confirmRecords: {
    id: string,
    name: string,
    amount: number,
    beneficiary: {
      bankCode: string,
      account: string,
      accountOwnerNames: string,
      currency: string,
    },
    currency: string,
    status: string,
    reason: string,
    accountNumber: string,
  }[],
}

const initialState: ProcessedRecords = {
  records: [],
  confirmRecords: [],
}

const ProcessedBulkRecords = createSlice({
  name: 'processedBulkRecords',
  initialState,
  reducers: {
    setProcessedBulkRecords: (state, action) => {
      state.records = action.payload
    },
    setConfirmRecords: (state, action) => {
      state.confirmRecords = action.payload
    },
    clearProcessedBulkRecords: (state) => {
      state.records = []
      state.confirmRecords = []
    }
  }
})

export const { setProcessedBulkRecords, setConfirmRecords, clearProcessedBulkRecords } = ProcessedBulkRecords.actions
export const getProcessedBulkRecords = (state: { processedBulkRecords: ProcessedRecords, }) => state.processedBulkRecords
export const getConfirmRecords = (state: { processedBulkRecords: ProcessedRecords, }) => state.processedBulkRecords.confirmRecords
export default ProcessedBulkRecords.reducer